import IGoogleMapConfig from '~/components/map/types/mapConfig';

const buildConfig = (isMobile: boolean): IGoogleMapConfig => ({
  zoom: 6,
  position: {
    lat: 52.0693,
    lng: 19.4803,
  },
  markersClickable: true,
  zoomOnClickCluster: true,
  clusterActiveElem: true,
  showCloseBtn: isMobile,
  streetViewIsVisible: false,
  options: {
    gestureHandling: 'greedy',
    streetViewControl: true,
    disableDefaultUI: false,
    zoomControl: false,
    fullscreenControl: false,
    mapTypeControl: true,
  },
  stylesheet: 'biura',
  isFullyLoaded: false,
});
export default buildConfig;
